// extracted by mini-css-extract-plugin
module.exports = {"button":"SelectionButton_button__226Cd","arrow":"SelectionButton_arrow__1TWkA","open":"SelectionButton_open__joOcz","label":"SelectionButton_label__2aV75"};